import { render, staticRenderFns } from "./NavMegaMenu.vue?vue&type=template&id=bfba6990&scoped=true&"
import script from "./NavMegaMenu.vue?vue&type=script&lang=ts&"
export * from "./NavMegaMenu.vue?vue&type=script&lang=ts&"
import style0 from "./NavMegaMenu.vue?vue&type=style&index=0&id=bfba6990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfba6990",
  null
  
)

component.options.__file = "NavMegaMenu.vue"
export default component.exports